import { render, staticRenderFns } from "./LabelNameBook.vue?vue&type=template&id=1ceb7d1e&scoped=true&lang=pug&"
import script from "./LabelNameBook.vue?vue&type=script&lang=ts&"
export * from "./LabelNameBook.vue?vue&type=script&lang=ts&"
import style0 from "./LabelNameBook.vue?vue&type=style&index=0&id=1ceb7d1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceb7d1e",
  null
  
)

export default component.exports